import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Edit, Clock, Tag } from 'lucide-react';
import { typesIntervention as typesData } from '../../data/mockData';

function ListeTypesIntervention({ user }) {
  const [types, setTypes] = useState(typesData);
  const [searchTerm, setSearchTerm] = useState('');

  const filteredTypes = types.filter(type =>
    type.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
    type.libelle.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1>Types d'intervention</h1>
          <p className="text-muted">Paramétrage des types d'intervention</p>
        </div>
        {user.role === 'admin' && (
          <Link to="/types-intervention/nouveau" className="btn btn-primary">
            <Plus size={20} />
            Ajouter un type
          </Link>
        )}
      </div>

      <div className="filters-bar">
        <input
          type="text"
          placeholder="Rechercher un type..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>

      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>Code</th>
              <th>Libellé</th>
              <th>Description</th>
              <th>Durée estimée</th>
              <th>Statut</th>
              {user.role === 'admin' && <th>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {filteredTypes.map(type => (
              <tr key={type.id}>
                <td>
                  <span 
                    className="type-badge" 
                    style={{ backgroundColor: type.couleur }}
                  >
                    {type.code}
                  </span>
                </td>
                <td><strong>{type.libelle}</strong></td>
                <td>{type.description}</td>
                <td>
                  <div className="flex items-center gap-1">
                    <Clock size={16} className="icon-muted" />
                    {type.dureeEstimee} min
                  </div>
                </td>
                <td>
                  <span className={`badge ${type.actif ? 'badge-success' : 'badge-secondary'}`}>
                    {type.actif ? 'Actif' : 'Inactif'}
                  </span>
                </td>
                {user.role === 'admin' && (
                  <td>
                    <Link
                      to={`/types-intervention/${type.id}/modifier`}
                      className="btn btn-sm btn-secondary"
                    >
                      <Edit size={16} />
                    </Link>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {filteredTypes.length === 0 && (
        <div className="empty-state">
          <Tag size={48} className="icon-muted" />
          <p>Aucun type d'intervention trouvé</p>
        </div>
      )}
    </div>
  );
}

export default ListeTypesIntervention;

